// eslint-disable-next-line unicorn/prevent-abbreviations
export default class KformDevToolbarController {
	/* @ngInject */
	/**
	 * @param {any} $copyToClipboard
	 */
	constructor($copyToClipboard) {
		this.$copyToClipboard = $copyToClipboard;
		this.disabled = false;
		/** @type {import('~/scripts/services/model/form').default | undefined} */
		this.form = undefined;
		this.parent = undefined;
		this.showDevToolbar = true;
	}

	closeDevToolbar() {
		this.showDevToolbar = false;
	}

	copyKid() {
		this.$copyToClipboard(this.form?.kid, true);
	}
}
